<template lang="pug">
  div(v-if='person')

    ods-row(:gutter='32')
      ods-col(:span='16')
        h2.mocuetitle {{ $t('commerceInfo.editData') }}
      ods-col(:span='8' class='right')
        h2.loyalty-cuentas-table__required.mocueherror {{ $t('loyalty.requiredFields') }}

    ods-row(:gutter='32')
      ods-col(:span='8')
        h2.mocueh2 {{ $t('loyalty.IdNumber') }}
        span.mocuespan {{ person.desctidc }} - {{ person.idclient }}
    div
      ods-form(label-position='top'
        :model='person'
        :rules='personRules'
        ref='updatePerson'
        :show-message='true')
        ods-row(:gutter='32')
          ods-col(:span='8')
            ods-form-item(:label="$t('loyalty.name')" prop='nombre')
              ods-input(v-model='person.nombre' :maxlength='40' :max='40')
          ods-col(:span='8')
            ods-form-item(:label="$t('loyalty.firstName')" prop='apellid1')
              ods-input(v-model='person.apellid1' :maxlength='36' :max='36')
          ods-col(:span='8')
            ods-form-item(:label="$t('loyalty.lastName')" prop='apellid2')
              ods-input(v-model='person.apellid2' :maxlength='36' :max='36')

        ods-row(:gutter='32')
          ods-col(:span='8')
            ods-form-item(:label="$t('loyalty.gender')" prop='sexo')
              ods-radio-group(v-model='person.sexo')
                ods-radio(label='V') {{ $t('loyalty.male') }}
                ods-radio(label='M') {{ $t('loyalty.female') }}
          ods-col(:span='8')
            ods-form-item(:label="$t('loyalty.maritalStatus')" prop="indestciv")
              ods-select(v-model="person.indestciv")
                ods-option(v-for="(item, index) in $t('loyalty.maritalStatusArr')"
                  :key="item"
                  :label="$t(`loyalty.maritalStatusArr[${index}]`)"
                  :value="index"
                  :disabled="index===0")
          ods-col(:span='8')
            ods-form-item(:label="$t('loyalty.birthDate')" prop='fecnac')
              ods-date-picker(v-model="person.fecnac.valueDate"
                :clearable="false"
                format='dd/MM/yyyy'
                :picker-options="datepickerOptions"
                type="date"
                v-on:click.native="activeIndexPicker")
        ods-row(:gutter='32')
          ods-col(:span='24')
            h2.mocuetitle {{ $t('loyalty.adress') }}

        ods-row(:gutter='32')
          ods-col(:span='8')
            ods-form-item(:label="$t('loyalty.region')" prop='codregion')
              ods-input(v-model='person.codregion' :maxlength='3' :max='3' auto-complete='off')
          ods-col(:span='8')
            ods-form-item(:label="$t('loyalty.city')" prop='poblacion')
              ods-input(v-model='person.poblacion' :maxlength='35' :max='35' auto-complete='off')
          ods-col(:span='8')
            ods-form-item(:label="$t('loyalty.postalCode')" prop='codpostal')
              ods-input(v-model='person.codpostal' :maxlength='10' :max='10' auto-complete='off')

        ods-row(:gutter='32')
          ods-col(:span='8')
            ods-form-item(:label="$t('loyalty.email')" prop='desclave1')
              ods-input(v-model='person.desclave1' :maxlength='50' :max='50' auto-complete='off')
          ods-col(:span='8')
            ods-form-item(:label="$t('loyalty.phone')" prop='desclave2')
              ods-input(v-model='person.desclave2' :maxlength='10' :max='10' auto-complete='off')

      ods-row.buttons-row(type='flex' justify="end")
        ods-button(type='text' @click="resetForm('updatePerson')") {{ $t('el.messagebox.cancel') }}
        ods-button(type='primary' @click="submitUpdatePerson('updatePerson')" :loading='loading') {{ $t('loyalty.save')}}
</template>
<script>
import { mapActions } from 'vuex'
import { Validator } from '@/utils/Validator.js'

export default {
  name: 'ModificaCliente',
  props: ['personData'],
  data () {
    var validateText = (rule, value, callback) => {
      if (rule.field === 'nombre' || rule.field === 'apellid1' || rule.field === 'apellid2' || rule.field === 'poblacion') {
        Validator.names(rule, value, callback)
      } else if (rule.field === 'fecnac') {
        Validator.birthDate(rule, value, callback)
      } else if (rule.field === 'indestciv') {
        Validator.maritalStatus(rule, value, callback)
      } else if (rule.field === 'sexo') {
        Validator.gender(rule, value, callback)
      } else if (rule.field === 'codregion') {
        Validator.regionCode(rule, value, callback)
      } else if (rule.field === 'codpostal') {
        Validator.postalCode(rule, value, callback)
      } else if (rule.field === 'desclave1') {
        Validator.email(rule, value, callback)
      } else if (rule.field === 'desclave2') {
        Validator.phone(rule, value, callback)
      }
    }
    return {
      loading: true,
      person: this.personData,
      personRules: {
        nombre: [{ required: true, validator: validateText }],
        apellid1: [{ required: true, validator: validateText }],
        apellid2: [{ required: false, validator: validateText }],
        sexo: [{ required: true, validator: validateText }],
        indestciv: [{ required: false, validator: validateText }],
        codregion: [{ required: false, validator: validateText }],
        poblacion: [{ required: false, validator: validateText }],
        codpostal: [{ required: true, validator: validateText }],
        fecnac: [{ required: false, validator: validateText }],
        desclave1: [{ required: false, validator: validateText, trigger: 'blur' }],
        desclave2: [{ required: false, validator: validateText }]
      },
      datepickerOptions: {
        disabledDate: function disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  mounted () {
    this.handleValidate('updatePerson')
    this.loading = false
  },
  destroyed () {
    this.person = null
  },
  methods: {
    ...mapActions(['updateClient']),
    async handleValidate (formName) {
      this.$refs[formName].validate((valid) => {
        console.log(`handleValidate ${valid}`)
        return valid
      })
    },
    async runService () {
      this.loading = true
      // console.log('runService')
      // console.log(this.person)
      this.updateClient(this.person).then(resp => {
        this.loading = false
        console.log(resp)
        if (resp.retorno === '000') {
          this.$notify({
            title: resp.descRetorno,
            type: 'success',
            position: 'top-left',
            offset: 150,
            duration: 3000
          })
          this.$emit('end-edit-client', {})
        }
      })
    },
    submitUpdatePerson (formName) {
      // console.log('Guardando...')
      this.runService()
      this.$refs[formName].validate((valido) => {
        // console.log(`updatePerson ${valido}`)
        if (valido) {
          // console.log(`¡VAMOOOOS! ${valido}`)
          this.runService()
        } else {
          // console.log(`Ouch... ${valido}`)
          return false
        }
      })
    },
    activeIndexPicker () {
      const picker = document.querySelector('.ods-date-picker')
      picker.style.zIndex = '9999'
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.$emit('end-edit-client', {})
    }
  }
}
</script>
<style lang="scss">
.right {
  text-align: end;
}
</style>
